import NotionPage from '../../schemas/NotionPageSchema';
import UniSearch from '../../api/uniSearch';

import { RESOURCE_TYPE } from '../../utilities/CONSTANTS';

const isTettraPageSuggestion = suggestion => suggestion.type === RESOURCE_TYPE.TETTRA_PAGE;

const isGoogleDriveSuggestion = suggestion => suggestion.type === RESOURCE_TYPE.GOOGLE_DOCS;

const isGithubSuggestion = suggestion => suggestion.type === RESOURCE_TYPE.GITHUB_ISSUE;

const MAX_SUGGESTIONS = 12;

const getExternalResourceSuggestions = (searchText) => {
    const promises = [];

    const integrationCount = !!window.githubSearch + !!window.googleDriveSearch + !!window.hasNotion;
    const maxResults = MAX_SUGGESTIONS / integrationCount;

    if (window.githubSearch) {
        promises.push(window.githubSearch(searchText, maxResults));
    }

    if (window.googleDriveSearch) {
        promises.push(window.googleDriveSearch(searchText, maxResults));
    }

    if (window.hasNotion) {
        promises.push(NotionPage.Search(searchText, maxResults));
    }

    return Promise.allSettled(promises)
        .then((results) => {
            let suggestions = [];
            results.forEach((result) => {
                if (result.status === 'rejected') {
                    console.error(result.reason);
                    return;
                }
                suggestions = suggestions.concat(result.value);
            });
            return suggestions;
        });
};

const getAllSuggestions = (searchText, team, source) => {
    const promises = [];

    const tettraSearch = new UniSearch(window.algoliaAppId, window.algoliaSearchKey, team, source);

    promises.push(tettraSearch(searchText));

    if (window.githubSearch) {
        const maxResults = window.googleDriveSearch ? 5 : 10;
        promises.push(window.githubSearch(searchText, maxResults));
    }

    if (window.googleDriveSearch) {
        const maxResults = window.githubSearch ? 5 : 10;
        promises.push(window.googleDriveSearch(searchText, maxResults));
    }

    return Promise.allSettled(promises)
        .then((results) => {
            let suggestions = [];
            results.forEach((result) => {
                if (result.status === 'rejected') {
                    console.error(result.reason);
                    return;
                }
                suggestions = suggestions.concat(result.value);
            });
            return suggestions;
        });
};

export {
    isGithubSuggestion, isGoogleDriveSuggestion, isTettraPageSuggestion, getExternalResourceSuggestions, getAllSuggestions,
};
